import { defineConfig } from "@sitecore-content-sdk/nextjs/config";

/**
 * @type {import('@sitecore-content-sdk/nextjs/config').SitecoreConfig}
 * See the documentation for `defineConfig`:
 * https://doc.sitecore.com/xmc/en/developers/content-sdk/the-sitecore-configuration-file.html
 */
export default defineConfig({
  api: {
    edge: {
      contextId:
        process.env.SITECORE_EDGE_CONTEXT_ID ||
        process.env.NEXT_PUBLIC_SITECORE_EDGE_CONTEXT_ID ||
        "",
      clientContextId: process.env.NEXT_PUBLIC_SITECORE_EDGE_CONTEXT_ID,
      edgeUrl: process.env.NEXT_PUBLIC_SITECORE_EDGE_PLATFORM_HOSTNAME,
    },
    local: {
      apiKey: process.env.NEXT_PUBLIC_SITECORE_API_KEY || "",
      apiHost: process.env.NEXT_PUBLIC_SITECORE_API_HOST || "",
    },
  },
  defaultSite: process.env.NEXT_PUBLIC_DEFAULT_SITE_NAME || "Dotcom",
  defaultLanguage: process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE || "en-US",
  editingSecret: process.env.SITECORE_EDITING_SECRET,
  redirects: {
    enabled: true,
    locales: [
      "en",
      "en-us",
      ...(process.env.ENABLED_LANGUAGES?.split(",").map((lang) =>
        lang.trim(),
      ) ?? []),
    ],
  },
  multisite: {
    enabled: true,
    useCookieResolution: () => process.env.VERCEL_ENV === "preview",
  },
  personalize: {
    enabled: false,
    scope: process.env.NEXT_PUBLIC_PERSONALIZE_SCOPE,
    edgeTimeout: parseInt(process.env.PERSONALIZE_MIDDLEWARE_EDGE_TIMEOUT!, 10),
    cdpTimeout: parseInt(process.env.PERSONALIZE_MIDDLEWARE_EDGE_TIMEOUT!, 10),
  },
  generateStaticPaths: process.env.GENERATE_STATIC_PATHS === "true",
  dictionary: {
    caching: {
      enabled: true,
      timeout: 60,
    },
  },
  sitecoreInternalEditingHostUrl: "http://localhost:3000",
});
